import colors from '../../../theme/foundations/colors'
import {fonts} from '../../../theme/foundations/fonts'
import {pxToRem} from '../../../utills/pxToRem'

export const containerStyle = {
    mx: {xl: pxToRem(165)},
    mb: {base: pxToRem(50), md: pxToRem(70), xl: pxToRem(20)},
    px: pxToRem(15)
}

export const imageTextStyle = {
    fontFamily: fonts.primary,
    color: 'black',
    m: 0,
    cursor: 'pointer',
    fontSize: pxToRem(30),
    fontWeight: 700,
    letterSpacing: pxToRem(1),
    textTransform: 'uppercase',
    _hover: {
        color: 'cav_red_separator'
    }
}

export const buttonStyle = {
    fontFamily: fonts.primary,
    color: 'white',
    bg: 'cav_red_separator',
    border: `${pxToRem(1)} solid ${colors.cav_border_gray}`,
    minW: {lg: pxToRem(160)},
    w: 'auto',
    h: {base: pxToRem(34), lg: pxToRem(35)},
    textTransform: 'uppercase',
    fontSize: pxToRem(14),
    px: 0,
    borderRadius: 0,
    whiteSpace: 'nowrap',
    _hover: {
        bg: 'white',
        color: 'cav_red_separator',
        border: `${pxToRem(1)} solid ${colors.cav_red_separator}`,
        textDecoration: 'none'
    }
}

export const headerTextStyle = {
    fontFamily: fonts.primary,
    color: 'cav_light_black',
    fontSize: pxToRem(24),
    fontWeight: 700,
    letterSpacing: pxToRem(1),
    lineHeight: pxToRem(30)
}

export const selectStyle = {
    fontFamily: fonts.primary,
    fontWeight: '600',
    fontSize: pxToRem(14),
    textTransform: 'uppercase',
    color: 'cav_light_black',
    borderColor: 'cav_light_black',
    borderRadius: pxToRem(3),
    px: pxToRem(10),
    _hover: {
        borderColor: 'cav_light_black'
    },
    _focus: {
        borderColor: 'cav_blue',
        borderWidth: pxToRem(2),
        boxShadow: 'none'
    },
    '& option': {
        textTransform: 'uppercase'
    }
}

export const dropdownBoxStyle = {
    border: {md: `${pxToRem(1)} solid black`},
    borderBottom: `${pxToRem(1)} solid black`,
    py: pxToRem(7),
    w: {base: '100%', md: pxToRem(200), xl: pxToRem(168)},
    h: pxToRem(44)
}

export const dropdownBoxSmallStyle = {
    border: `${pxToRem(1)} solid black`,
    w: {xl: pxToRem(195)},
    h: {xl: pxToRem(40)},
    display: 'flex',
    alignItems: 'center',
    px: {xl: pxToRem(20)}
}

export const paginationButtonStyle = {
    fontFamily: fonts.primary,
    fontSize: {base: pxToRem(16), lg: pxToRem(14)},
    fontWeight: 700,
    minW: pxToRem(10),
    w: pxToRem(10),
    h: pxToRem(10),
    p: 0,
    color: 'cav_dark_red',
    textDecoration: 'underline',
    textTransform: 'uppercase',
    _hover: {textDecoration: 'none'}
}

export const paginationButtonActiveStyle = {
    ...paginationButtonStyle,
    textDecoration: 'none',
    color: 'cav_light_black',
    pt: pxToRem(1)
}

export const menuListStyle = {
    borderColor: 'cav_border_gray',
    borderRadius: 0,
    mt: pxToRem(-1),
    maxW: {xl: pxToRem(200)},
    w: {xl: pxToRem(200)}
}

export const menuButtonActiveStyle = {
    ...buttonStyle,
    bg: 'white',
    color: 'cav_red_separator',
    border: `${pxToRem(1)} solid ${colors.cav_red_separator}`,
    textDecoration: 'none'
}

export const menuItemStyle = {
    fontFamily: fonts.primary,
    fontWeight: '600',
    textTransform: 'uppercase',
    color: 'cav_light_black',
    px: {xl: pxToRem(8)},
    py: {xl: pxToRem(2)},
    fontSize: {xl: pxToRem(14)},
    justifyContent: 'flex-start',
    textAlign: 'left',
    h: 'auto',
    minH: 'auto',
    _hover: {
        color: colors.red.cvs
    },
    _focus: {
        bg: 'white'
    }
}

export const clearButtonStyle = {
    fontFamily: fonts.primary,
    w: pxToRem(220),
    h: pxToRem(32),
    bg: 'cav_hover_brightred',
    border: `${pxToRem(1)} solid ${colors.cav_border_gray}`,
    textTransform: 'uppercase',
    color: 'black',
    borderRadius: 0,
    fontSize: pxToRem(14),
    lineHeight: pxToRem(18),
    letterSpacing: pxToRem(1),
    _hover: {
        bg: 'white',
        color: 'cav_hover_brightred',
        border: `${pxToRem(1)} solid ${colors.cav_hover_brightred}`,
        textDecoration: 'none'
    }
}

export const secondRowStyle = {
    minW: {base: '100%', lg: pxToRem(228)},
    w: {base: '100%', lg: pxToRem(228)},
    pl: {md: pxToRem(20)},
    pr: {lg: pxToRem(20), xl: 0},
    mt: {base: '21px', lg: 0}
}

export const yearStyle = {
    minW: {base: '100%', lg: pxToRem(228), xl: pxToRem(257)},
    w: {base: '100%', lg: pxToRem(228), xl: pxToRem(257)},
    minH: pxToRem(38),
    h: pxToRem(38),
    fontSize: pxToRem(14),
    fontWeight: 700,
    borderRadius: 0,
    color: 'cav_night_rider',
    fontFamily: fonts.primary,
    letterSpacing: pxToRem(2),
    lineHeight: pxToRem(18),
    _hover: {
        bg: 'cav_light_gray_bg',
        color: 'cav_hover_brightred',
        textDecoration: 'none'
    }
}

export const yearActiveStyle = {
    ...yearStyle,
    bg: 'cav_light_gray_bg',
    color: 'cav_hover_brightred',
    textDecoration: 'underline'
}

export const monthStyle = {
    minW: {base: '100%', xl: pxToRem(257), lg: pxToRem(228)},
    w: {base: '100%', xl: pxToRem(257), lg: pxToRem(228)},
    h: pxToRem(38),
    minH: pxToRem(38),
    borderRadius: 0,
    color: 'cav_night_rider',
    fontSize: pxToRem(12),
    fontWeight: 400,
    fontFamily: fonts.primary,
    px: {md: pxToRem(20)},
    py: {md: pxToRem(10)},
    textTransform: 'uppercase',
    letterSpacing: pxToRem(2),
    lineHeight: pxToRem(18),
    _hover: {
        bg: 'cav_light_gray_bg',
        color: 'cav_hover_brightred',
        textDecoration: 'none'
    }
}

export const monthActiveStyle = {
    ...monthStyle,
    bg: 'cav_light_gray_bg',
    color: 'cav_hover_brightred',
    textDecoration: 'underline'
}
